import { render, staticRenderFns } from "./ElapsedTime.vue?vue&type=template&id=0ffafb47&scoped=true&"
import script from "./ElapsedTime.vue?vue&type=script&lang=js&"
export * from "./ElapsedTime.vue?vue&type=script&lang=js&"
import style0 from "./ElapsedTime.vue?vue&type=style&index=0&id=0ffafb47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffafb47",
  null
  
)

component.options.__file = "ElapsedTime.vue"
export default component.exports